import * as React from "react"

import "./odomoter-theme-minimal.scss"

interface IProps {
  duration?: number
  format?: string
  value: number
}

const LazyOdometer = React.lazy(() => import("react-odometerjs"))

const Odometer = ({ duration = 500, format = "(,ddd)", value }: IProps) => {
  const isSSR = typeof window === "undefined"

  // Do not show odometer on server side rendered page because document is not available

  return (
    <>
      {!isSSR && (
        <React.Suspense fallback={<div />}>
          <LazyOdometer format={format} duration={duration} value={value} />
        </React.Suspense>
      )}
    </>
  )
}

export default Odometer
